import EditOrder from '@app/components/order/EditOrder';
import React from 'react';

const OrderEditPage: React.FC = () => {
  
  return (
    <EditOrder />
  );
};

export default OrderEditPage;
